import {
  setDataUser,
  setDataAccess,
  getUserData,
  getAccessData
} from '@/auth'

import * as MutationTypes from '../mutation-types'

import { underLoadingFunction } from '../helpers/under-loading'
// import { errorResponseHelper } from '@/helpers'

const state = {
  token: '',
  roles: [],
  user: {}
}

const mutations = {
  [MutationTypes.SET_TOKEN]: (mutationState, token) => {
    mutationState.token = token
  }
}

const actions = {
  saveDataUser: underLoadingFunction(async({ commit }, { code, key }) => {
    try {
      if (!code || !key) {
        return false
      }

      const accessSaved = await setDataAccess(key)
      const userSaved = accessSaved && await setDataUser(code)
      return Boolean(userSaved && await getUserData() === code && await getAccessData() === key)
    } catch (error) {
      return false
    }
  }),
  resetTokenAccess({ commit }) {
    return new Promise(resolve => {
      commit(MutationTypes.SET_TOKEN, '')
      resolve(true)
    })
  }
}

export default {
  state,
  mutations,
  actions
}
